import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { contract } from '@aviv_price-pages/brand';
import { ApplicationRouter, Route, useLocation } from '@aviv-unified-frontend/runtime/router';
import { HtmlMetas } from '@/components/HtmlMetas';
import { Seo } from '@/components/Seo/Seo';
import { useI18n } from '@/hooks/useI18n/useI18n';
import { useMobileViewDetect } from '@/hooks/useMobileViewDetect/useMobileViewDetect';
import { usePageLayoutContext } from '@/hooks/usePageLayoutContext/usePageLayoutContext';
import { useThorPageView } from '@/hooks/useThorPageView/useThorPageView';
import { ShellLayout } from '@/Layouts/ShellLayout';
import CityStreetsPage from '@/pages/CityStreetsPage';
import CountryPage from '@/pages/CountryPage';
import { PageDispatcher } from '@/pages/PageDispatcher';
const Router = () => {
    useI18n();
    const { pricePageProps, setSidebarOpen } = usePageLayoutContext();
    const { isMobileView } = useMobileViewDetect();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    useEffect(() => {
        searchParams.get('view') === 'map' && isMobileView && setSidebarOpen(false);
    }, []);
    useThorPageView();
    return (_jsxs(_Fragment, { children: [_jsx(HtmlMetas, {}), _jsx(Seo, { pricePageContext: pricePageProps.pricePageContext }), _jsxs(ApplicationRouter, { children: [contract.cityStreetsPaths?.map((path) => (_jsx(Route, { path: path, element: _jsx(CityStreetsPage, {}) }, path))), _jsxs(Route, { element: _jsx(ShellLayout, {}), children: [contract.countryPagePath?.map((path) => (_jsx(Route, { path: path, element: _jsx(CountryPage, {}) }, path))), _jsx(Route, { path: "*", element: _jsx(PageDispatcher, { place: pricePageProps.pricePageContext.place }) })] })] })] }));
};
export default Router;
